import addToCart from '#/local/service/addToCart'
import addToCartEshop from '#/local/service/addToCart/eshop'
import addToCartRental from '#/local/service/addToCart/rental'
import addToCartAfter from '#/local/service/addToCartAfter'
import addToCartEshopAfter from '#/local/service/addToCartAfter/eshop'
import addToCartRentalAfter from '#/local/service/addToCartAfter/rental'
import initProductSliderUserTarget from '#/local/service/productSliderUserTarget'

import { addMessage, openBranchChange } from '#/local/service'

window.addEventListener('ES_ADD_TO_CART', addToCart)
window.addEventListener('ES_ADD_TO_CART_ESHOP', addToCartEshop)
window.addEventListener('ES_ADD_TO_CART_RENTAL', addToCartRental)

window.addEventListener('ES_ADD_TO_CART_AFTER', addToCartAfter)
window.addEventListener('ES_ADD_TO_CART_ESHOP_AFTER', addToCartEshopAfter)
window.addEventListener('ES_ADD_TO_CART_RENTAL_AFTER', addToCartRentalAfter)

window.addEventListener('ES_INIT_PRODUCT_SLIDER_USER_TARGET', initProductSliderUserTarget)

window.addEventListener('ES_ADD_MESSAGE_FLASH', addMessage)

window.addEventListener('ES_OPEN_BRANCH_CHANGE', openBranchChange)
